import api from '@/api/search'
const state = {
   isTra: localStorage.getItem('lanEncoding') === null ? false : localStorage.getItem('lanEncoding'),
   confidentialSourceIds: []
}

const actions = {
    async getConfidentialSourceIds ({ commit }) {
        let res = await api.getConfidentialSourceIds()
        commit('setConfidentialSourceIds', res)
        return res
    }
}
const mutations = {
    toggleIsTra (state) {
        state.isTra = !state.isTra
        localStorage.setItem('lanEncoding', state.isTra)
    },
    setConfidentialSourceIds (state, val) {
        state.confidentialSourceIds = val
    }
}

export default {
    state,
    actions,
    mutations
}
